import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2, Loader2 } from "lucide-react";
import { adminApi } from "./adminApi";
import { ARTICLES } from "@/content/articles";
import { useCovers, refreshCovers } from "@/pages/blog/useCovers";

const Row = ({ a, cover }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); await refreshCovers(); toast.success(ok); }
    catch (e) { toast.error(e.response?.data?.detail || "Operazione non riuscita"); }
    finally { setBusy(false); }
  };
  const upload = (file) => {
    const fd = new FormData();
    fd.append("file", file);
    run(() => adminApi.put(`/admin/blog/covers/${a.slug}`, fd), "Copertina aggiornata");
  };
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4 rounded-3xl bg-[#FCFBF7] border border-[#1B3B28]/10 p-4" data-testid={`cover-row-${a.slug}`}>
      <div className="w-full sm:w-40 aspect-[16/10] rounded-2xl overflow-hidden bg-[#E6ECE4] grid place-items-center shrink-0">
        {cover || a.cover ? <img src={cover || a.cover} alt="" className="w-full h-full object-cover" data-testid={`cover-preview-${a.slug}`} /> : <span className="text-xs text-[#526356]">Nessuna copertina</span>}
      </div>
      <div className="flex-1 min-w-0">
        <p className="eyebrow text-[#3E6B48]">{a.category}</p>
        <p className="f-serif text-2xl text-[#1B3B28] leading-tight mt-1">{a.title}</p>
      </div>
      <div className="flex gap-2 shrink-0">
        <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} data-testid={`cover-input-${a.slug}`} />
        <button onClick={() => input.current.click()} disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] px-4 py-2.5 text-sm hover:bg-[#3E6B48] disabled:opacity-60" data-testid={`cover-upload-${a.slug}`}>
          {busy ? <Loader2 size={15} className="animate-spin" /> : <ImagePlus size={15} />} {cover ? "Cambia" : "Carica"}
        </button>
        {cover && (
          <button onClick={() => run(() => adminApi.delete(`/admin/blog/covers/${a.slug}`), "Copertina rimossa")} disabled={busy} className="grid place-items-center w-10 h-10 rounded-full border border-[#1B3B28]/15 text-[#9A4B3C] hover:bg-[#F4E9E6]" aria-label="Rimuovi copertina" data-testid={`cover-remove-${a.slug}`}>
            <Trash2 size={15} />
          </button>
        )}
      </div>
    </div>
  );
};

export const BlogCoversTab = () => {
  const covers = useCovers({ withDefaults: false });
  return (
    <div data-testid="blog-covers-tab">
      <p className="text-sm text-[#526356] max-w-2xl">Carica una foto o un'illustrazione di copertina per ogni articolo (JPG, PNG o WEBP, max 8 MB). Viene ottimizzata in automatico e compare nel blog, in homepage e nelle storie Instagram.</p>
      <div className="mt-6 space-y-3">{ARTICLES.map((a) => <Row key={a.slug} a={a} cover={covers[a.slug]} />)}</div>
    </div>
  );
};
